// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"4c2d4ff7","673":"f0f1d3de","780":"bbd9418c"}[chunkId] + ".chunk.js";
};